import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "./components/layout/AppLayout";

import Dashboard from "./pages/Dashboard";
import LeadDetail from "./pages/LeadDetail";
import Login from "./pages/Login";
import SetupPassword from "./pages/SetupPassword";
import UserManagement from "./pages/UserManagement";
import ActivityLogs from "./pages/ActivityLogs";
import Pipeline from "./pages/Pipeline";
import Revenue from "./pages/Revenue";
import KnowledgeBase from "./pages/KnowledgeBase";
import TeamPerformance from "./pages/TeamPerformance";
import Sequences from "./pages/Sequences";
import Leads from "./pages/Leads";

const ProtectedRoute = ({ children, user }) => {
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <AppLayout>{children}</AppLayout>;
};

const AdminRoute = ({ children, user }) => {
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return <AppLayout>{children}</AppLayout>;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    if (token && userData) {
      try { setUser(JSON.parse(userData)); }
      catch { localStorage.removeItem("token"); localStorage.removeItem("user"); }
    }
    setLoading(false);
  }, []);

  if (loading) return <div className="min-h-screen bg-zinc-50 flex items-center justify-center text-sm text-zinc-500">Loading...</div>;

  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!user ? <Login setUser={setUser} /> : <Navigate to="/" replace />} />
          <Route path="/setup-password" element={<SetupPassword />} />

          <Route path="/" element={<ProtectedRoute user={user}><Dashboard user={user} /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute user={user}><Leads /></ProtectedRoute>} />
          <Route path="/leads/:id" element={<ProtectedRoute user={user}><LeadDetail user={user} /></ProtectedRoute>} />
          <Route path="/lead/:id" element={<ProtectedRoute user={user}><LeadDetail user={user} /></ProtectedRoute>} />
          <Route path="/pipeline" element={<ProtectedRoute user={user}><Pipeline /></ProtectedRoute>} />
          <Route path="/revenue" element={<ProtectedRoute user={user}><Revenue /></ProtectedRoute>} />
          <Route path="/kb" element={<ProtectedRoute user={user}><KnowledgeBase /></ProtectedRoute>} />
          <Route path="/team" element={<ProtectedRoute user={user}><TeamPerformance /></ProtectedRoute>} />
          <Route path="/activity" element={<ProtectedRoute user={user}><ActivityLogs /></ProtectedRoute>} />
          <Route path="/sequences" element={<ProtectedRoute user={user}><Sequences /></ProtectedRoute>} />
          <Route path="/users" element={<AdminRoute user={user}><UserManagement user={user} /></AdminRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
